module.exports = __webpack_public_path__ + "static/media/romania-flag.9e626844.png";